import React, { forwardRef } from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'


const fontSizeArr = ['8px','9px','10px','12px','14px','16px','20px','24px','32px','42px','54px','68px','84px','98px'];

const fontType= [
	"arial",
	"montserrat",
	"comic-sans",
	"courier-new",
	"georgia",
	"helvetica",
	"lucida",
  ];
const Quill = ReactQuill.Quill
var Size = Quill.import('attributors/style/size');
const Font = Quill.import("formats/font");
Font.whitelist = fontType;
Quill.register(Font, true);
Size.whitelist = fontSizeArr;
Quill.register(Size, true);




const RichTextEditor = forwardRef((props, ref) => {

	return (
		<div className="rich-text-editor">
			<ReactQuill ref={ref} {...props} modules={RichTextEditor.modules} formats={RichTextEditor.formats}  />
		</div>
	)
})

RichTextEditor.modules = {
	toolbar: [
	  [{ 'header': '1'}, {'header': '2'}],
	  [{ 'font': fontType }],
	  [{'size': fontSizeArr}],
	  ['bold', 'italic', 'underline', 'strike', 'blockquote'],
	  [{'list': 'ordered'}, {'list': 'bullet'}, 
	   {'indent': '-1'}, {'indent': '+1'}],
	  ['link', 'image'],
	  ['clean']
	]
}

RichTextEditor.formats = [
	'header', 'font', 'size',
	'bold', 'italic', 'underline', 'strike', 'blockquote',
	'list', 'bullet', 'indent',
	'link', 'image'
  ]

export default RichTextEditor
